module.exports = __webpack_public_path__ + "static/media/BMODE_b3fb6fd0-6200-4eec-8550-dd32e502e563.9a512ea3.jpg";